$(document).on("click", ".confirm", function (e) {
    e.preventDefault();
    const $this = $(this);
    const url = $this.attr("href");
    const json = $this.data("json");
    const data = {
        data: json,
        _token:
            $this.data("token") || $('meta[name="csrf-token"]').attr("content"),
    };
    Swal.fire({
        title: $this.data("confirm-title") || "Onaylıyor musunuz?",
        html: $this.data("confirm-text") || "İşlemi onaylıyor musunuz?",
        icon: $this.data("confirm-icon") || "warning",
        confirmButtonText: $this.data("confirm-approve") || "Onaylıyorum!",
        cancelButtonText: $this.data("confirm-cancel") || "Vazgeç!",
        showLoaderOnConfirm: true,
        showCancelButton: true,
        customClass: {
            confirmButton: "btn btn-primary me-3",
            cancelButton: "btn btn-secondary",
        },
        preConfirm: () => {
            const messageInput = document.getElementById("message");

            if (messageInput) {
                if (!messageInput.value) {
                    return Swal.showValidationMessage(
                        `Lütfen formu doldurunuz...`
                    );
                }

                Object.assign(data, {
                    description: messageInput.value,
                });
            }
            return fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(response.statusText);
                    }
                    return response.json();
                })
                .catch(function (error) {
                    Swal.showValidationMessage(`Request failed:  ${error}`);
                });
        },
        backdrop: true,
        allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
        if (result.isConfirmed) {
            if (result.value.status) {
                const remove = $this.data("remove");
                switch (remove) {
                    case "modal":
                        window.location.reload();
                        break;
                    case "productList":
                        switch (json.affiliate_status) {
                            case 0:
                                $this
                                    .removeClass(
                                        "btn-outline-danger confirm"
                                    )
                                    .addClass("btn-success text-white")
                                    .attr(
                                        "data-original-title",
                                        "Ürününüz satışa kapandı"
                                    )
                                    .prop("disabled", true);
                                break;
                            case 1:
                                $this
                                    .removeClass(
                                        "btn-outline-danger btn-outline-success confirm"
                                    )
                                    .addClass("btn-warning text-white")
                                    .attr(
                                        "data-original-title",
                                        "Ürününüz Onay Bekliyor"
                                    )
                                    .prop("disabled", true);
                                break;

                            default:
                                $this
                                    .removeClass(
                                        "btn-outline-danger btn-outline-success confirm"
                                    )
                                    .addClass("btn-secondary text-white")
                                    .attr(
                                        "data-original-title",
                                        json.affiliate_status === 4
                                            ? "Ürün satışçılara açıldı!"
                                            : "Ürün satışçılara kapandı!"
                                    )
                                    .prop("disabled", true);
                                break;
                        }

                        break;
                    case "confirm":
                        switch (json.affiliate_status) {
                            case 0:
                                $this
                                    .parent()
                                    .parent()
                                    .find(".itemText")
                                    .html(
                                        `<span class="text-danger">Satışçılara kapalı</span>`
                                    );
                                $this
                                    .parents(".button-cell")
                                    .html(
                                        `<span class="text-danger">Ürün Satışçılara Kapandı!</span>`
                                    );
                                break;
                            case 1:
                                $this
                                    .parent()
                                    .parent()
                                    .find(".itemText")
                                    .html(
                                        `<span class="text-warning">Onay Bekliyor</span>`
                                    );
                                $this
                                    .parents(".button-cell")
                                    .html(
                                        `<span class="text-warning">Ürün Onaya Gönderildi!</span>`
                                    );
                                break;
                            case 4:
                                $this
                                    .parent()
                                    .parent()
                                    .find(".itemText")
                                    .html(
                                        `<span class="text-success">Satışçılara Açık</span>`
                                    );
                                $this
                                    .parents(".button-cell")
                                    .html(
                                        `<span class="text-success">Ürün Satışçılara Açıldı!</span>`
                                    );
                                break;
                        }
                        break;
                    default:
                        $this.parents(remove).remove();
                        break;
                }

                toastr.success(result.value.message);
            } else {
                toastr.error(result.value.message);
            }
        }
    });
});
